import { type EventJoin, createEventJoin } from 'models';
import { useMutation } from 'query';
import type { ApiClientResponseError, NodeApiError } from 'common/services';
import { joinNodeEvent } from '../services';

type EnterEventBigMarkerParams = {
  email?: string;
  exitUri: string;
  firstName?: string;
  id: string;
  invitationToken?: string;
  lastName?: string;
};

export const useEnterEventBigMarker = () =>
  useMutation<EventJoin, EnterEventBigMarkerParams, ApiClientResponseError<NodeApiError>>({
    async mutationFn({ email, exitUri, firstName, id, invitationToken, lastName }) {
      const response = await joinNodeEvent({
        body: { email, exitUri, firstName, lastName },
        config: invitationToken
          ? {
              headers: {
                authorization: `Bearer ${invitationToken}`,
              },
              skipAuth: true,
            }
          : undefined,
        routeParams: { id },
      });

      return createEventJoin(response.data);
    },
  });
